/* eslint-disable */
import React from 'react'
import {Icon, message} from 'antd'
import {MDBBreadcrumb, MDBBreadcrumbItem} from 'mdbreact'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import moment from 'moment'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import {saveAs} from 'file-saver'
import SearchCustomer from '../BaseComponent/SearchCustomer'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'

class ReportUser extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      loadingText: '',
      disabledButton: false,
      userCode: ''
    }
  }
  componentDidMount() {
    var urlParams = new URLSearchParams(window.location.search)
    var userCode = urlParams.get('userCode') === null ? '' : urlParams.get('userCode')
    if (userCode !== '') {
      this.getSingleCustomerCode(userCode)
    }
  }

  changeFromDate = (date) => {
    this.setState({selectedDateFrom: date})

    // this.toDateInput.focus();
  }

  changeToDate = (date) => {
    this.setState({selectedDateTo: date})
    // this.toDateInput.focus();
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  toDate(props) {
    return <input className="form-control" {...props} />
  }

  submit(e) {
    e.preventDefault()
  }

  getSingleCustomerCode = (userCode) => {
    this.setState({
      userCode
    })
  }

  getPDF() {
    let maxDate = document.getElementById('selectedDateTo').value
    let userCode = this.state.userCode
    if (maxDate == '') {
      message.error('هر دو تاریخ وارد شود')
    } else if (userCode == '') {
      message.error('کد کاربر وارد شود')
    } else {
      JASPERREPORT(
        `report/jasper/transactions/user?fromTime=-2340524800000&toTime=${this.epochTo(
          this.convertDigit(maxDate)
        )}&userCode=${userCode}`
      )
    }
  }

  render() {
    let {selectedDateTo} = this.state
    return (
      <div className="rtl printA4Page">
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>گزارشات</li>
            <li>عمومی</li>
            <li>گزارش تراکنش کاربر</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>گزارش تراکنش کاربر</p>
            </div>
            <div className="formComponent">
              <label>
                تاریخ پایان :<span className="requireFiled">*</span>
              </label>
              <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                <DatePicker
                  okLabel="تأیید"
                  cancelLabel="لغو"
                  autoOk={true}
                  leftArrowIcon={<Icon type="left" />}
                  rightArrowIcon={<Icon type="right" />}
                  labelFunc={(date) => (date ? date.format('jYYYY/jMM/jDD') : '')}
                  onChange={this.changeToDate}
                  TextFieldComponent={this.toDate}
                  id="selectedDateTo"
                  name="selectedDateTo"
                  value={selectedDateTo}
                  ref={(node) => (this.toDateInput = node)}
                  readOnly
                />
              </MuiPickersUtilsProvider>

              {/*<label>کد کاربر<span className='requireFiled'>*</span></label>*/}
              {/*<input type='text' className='form-control' id='userCode'/>*/}
            </div>

            <SearchCustomer
              label={'کد کاربر'}
              getSingleCustomerCode={this.getSingleCustomerCode}
              singleResult={true}
              getValueFromThisPage={this.state.userCode}
              searchLabel={'جست و جوی مشتری'}
            />
            <div className="formComponent">
              <button className="btn btn-info btn-block jasperBtn" onClick={this.getPDF.bind(this)}>
                گزارش تراکنش ها
              </button>
              <p className="errorText" id="errorText" />
            </div>
          </form>
        </div>
      </div>
    )
  }
}
export default ReportUser
